import React, { useState } from "react";
import axios from "axios";

function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

  const whereToBuyStores = [
    { name: "The Don Deli, Doncaster East", url: "https://www.instagram.com/thedon.deli/?hl=en" },
    { name: "McAdams Apple, Croydon North", url: "https://www.instagram.com/mcadamsapple/?hl=en" },
    { name: "Nature's Green Farm, Eastland, Ringwood", url: "https://www.instagram.com/naturesgreenfarm/" },
    { name: "Pinewood Market, Mount Waverley", url: "https://www.facebook.com/p/Pinewood-market-61557165216816/" },
    { name: "Deli World, Chirnside Park", url: "https://deliworldchirnsidepark.com/" },
    { name: "Orlando's Greek Delicatessen, Doncaster", url: "https://www.orlandosgreekdeli.com" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      setError("Please enter a valid email address");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/api/subscribe`, {
        email: email.trim().toLowerCase(),
      });

      console.log("Email submitted successfully:", response.data);
      setSubmitted(true);
      setEmail("");

      setTimeout(() => {
        setSubmitted(false);
      }, 3000);
    } catch (err) {
      console.error("Error submitting email:", err);
      if (err.response) {
        setError(err.response.data.error || "Something went wrong. Please try again.");
      } else if (err.request) {
        setError("Network error. Please check your connection and try again.");
      } else {
        setError("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <footer id="contact" className="bg-gradient-to-br from-blue-950 via-blue-900 to-blue-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-6">
              <img src="/images/logo.png" alt="De Galapagos Logo" className="w-12 h-12 mr-4" />
              <div>
                <h3 className="text-2xl font-bold">De Galapagos</h3>
                <p className="text-blue-200 text-sm">Premium Ecuadorian Tuna</p>
              </div>
            </div>
            <p className="text-blue-100 leading-relaxed mb-6 max-w-md">
              Committed to sustainable fishing practices and delivering the finest quality tuna products
              from the pristine waters of Ecuador to your table.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3">
              <li><a href="#about" className="text-blue-100 hover:text-white transition-colors duration-200">About Us</a></li>
              <li><a href="#products" className="text-blue-100 hover:text-white transition-colors duration-200">Our Products</a></li>
              <li><a href="#recipes" className="text-blue-100 hover:text-white transition-colors duration-200">Recipes</a></li>
            </ul>
          </div>

          {/* Where To Buy */}
          <div id="where-to-buy">
            <h4 className="text-lg font-semibold mb-6 text-white">Where to Buy</h4>
            <ul className="space-y-3">
              {whereToBuyStores.map((store) => (
                <li key={store.name}>
                  <a
                    href={store.url}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-100 hover:text-white transition-colors duration-200"
                  >
                    {store.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <img src="/images/icon_email.png" alt="Location" className="w-9 h-10" />
                <div>
                  <p className="text-blue-100 text-sm">Email</p>
                  <a href="mailto:info@degalapagos.com.au" className="text-white hover:text-blue-200 transition-colors duration-200">
                    info@degalapagos.com.au
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <img src="/images/icon_location.png" alt="Location" className="w-9 h-8" />
                <div>
                  <p className="text-blue-100 text-sm">Address</p>
                  <p className="text-white">PO Box 574, Croydon, Victoria 3136</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <button onClick={() => window.open('https://www.facebook.com/profile.php?id=61589007107848', '_blank')} className="w-10 h-10 bg-white/10 hover:bg-white/20 flex items-center justify-center transition-all duration-200 hover:scale-110" title="Facebook">
                  <img src="/images/icon_fb.png" alt="Location" className="w-7 h-6" />
                </button>
                <button onClick={() => window.open('https://www.instagram.com/degalapagos.au', '_blank')} className="w-10 h-10 bg-white/10 hover:bg-white/20 flex items-center justify-center transition-all duration-200 hover:scale-110" title="Instagram">
                  <img src="/images/icon_insta.png" alt="Location" className="w-9 h-6" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Newsletter Signup */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-12">
          <div className="text-center max-w-2xl mx-auto">
            <h4 className="text-xl font-semibold mb-4 text-white">Stay Updated</h4>
            <p className="text-blue-100 mb-6">Subscribe to our newsletter for the latest recipes, sustainability updates, and exclusive offers.</p>
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 rounded-lg bg-white/20 border border-white/30 text-white placeholder-blue-200 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent"
                disabled={loading}
                required
              />
              <button
                type="submit"
                className="px-6 py-3 bg-white text-blue-900 font-semibold rounded-lg hover:bg-blue-50 transition-all duration-200 transform hover:scale-105 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Subscribe"}
              </button>
            </form>

            {submitted && !error && (
              <p className="mt-4 text-green-200 font-medium">Thank you! You are subscribed.</p>
            )}

            {error && (
              <p className="mt-4 text-red-200 font-medium">{error}</p>
            )}
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-center items-center">
            <p className="text-blue-200 text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} De Galapagos. All rights reserved.
            </p>
            {/*
            <div className="flex space-x-6 text-sm">
              <a href="/privacy-policy" className="text-blue-200 hover:text-white transition-colors duration-200">Privacy Policy</a>
              <a href="/terms-of-service" className="text-blue-200 hover:text-white transition-colors duration-200">Terms of Service</a>
              <a href="/cookie-policy" className="text-blue-200 hover:text-white transition-colors duration-200">Cookie Policy</a>
            </div>
              */}
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-bl from-blue-400/20 to-transparent rounded-full -translate-y-32 translate-x-32"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-gradient-to-tr from-indigo-400/20 to-transparent rounded-full translate-y-24 -translate-x-24"></div>
    </footer>
  );
}

export default Footer;
